import React from 'react';
import {observer, inject} from 'mobx-react';
import {autorun} from 'mobx';
import {withRouter} from 'react-router-dom';
import {Menu, Popover} from '@enos/dpl';
import localeText, {getLocale} from '@locale';
import AppSwitcher from './AppSwitcher';
import store from './store';
import {Mobile, DesktopOrTablet} from '~/components/Responsive';
import {checkIconExist} from '~/utils/tools';

import './index.less';
import './mobile.less';

const {SubMenu} = Menu;

@inject((stores, props) => {
  const {portalStore, sessionStore, organizationStore, appStore} = stores;
  return {
    ...props,
    portalStore,
    sessionStore,
    organizationStore,
    appStore,
    uiStore: store
  };
})
@withRouter
@observer
class PortalMenu extends React.Component {
  static defaultProps = {
    prefixClass: 'component-portal-menu',
    newPrefixClass: 'new-component-portal-menu'
  };

  componentDidMount() {
    const {portalStore, organizationStore, uiStore} = this.props;
    organizationStore.getOrganizationCopyRight();
    this.dispose = autorun(() => {
      const {workingMenu} = portalStore;
      if (workingMenu && workingMenu.code) {
        (portalStore.currentAppMenus || []).forEach((item) => {
          if (item.code === workingMenu.code || (item.children || []).some(({code}) => workingMenu.code === code)) {
            uiStore.setOpenKeys(item.id);
          }
        });
      }
    });
  }

  componentWillUnmount() {
    this.dispose();
  }

  findMenuById = (mId) => {
    let menu = {};
    this.props.portalStore.currentAppMenus.some((item) => {
      if (item.children && item.children.length > 0) {
        // eslint-disable-next-line
        menu = item.children.find(({id}) => mId === id);
        if (menu) {
          return true;
        }
      }

      if (item.id === mId) {
        menu = item;
        return true;
      }
      return false;
    });
    return menu;
  };

  menuSelect = (item) => {
    const {portalStore, sessionStore, onClose} = this.props;
    let jumpMenu;
    let code;
    if (item.children?.length) {
      const defaultJumpMenu = this.findMenuById(item.jumpLocation);
      jumpMenu = defaultJumpMenu || this.findMenuById(item.children[0].id);
      code = jumpMenu.code;
    } else {
      code = this.findMenuById(item.id)?.code;
    }
    sessionStore.tokenRenewal();
    window.$sdk$.setPageTitle(item.name);
    window.$sdk$.switchPage({
      appId: portalStore.workingApp.id,
      menuCode: code
    });

    if (typeof onClose === 'function') {
      onClose(code);
    }
  };

  renderMenu = (item) => {
    const {portalStore, appStore} = this.props;
    let defaultKey = portalStore.workingMenu.id;
    if (item.children?.length) {
      defaultKey = portalStore.workingMenu.parentId;
    }
    const isNewNavigation = portalStore.isNewNavigation && appStore.appRunEnable;
    return (
      <li
        {...{[['key'][0]]: item.id}}
      >
        <span
          title={item.name}
          className={defaultKey === item.id ? 'menu-item selected' : 'menu-item'}
          onClick={() => this.menuSelect(item)}
        >
          {
            isNewNavigation && <span className={item.icon && checkIconExist(item.icon) ? `${item.icon} menu-icon` : 'icon_model menu-icon'} />
          }
          {item.name}
        </span>
      </li>
    );
  };

  toggleSubMenu = (id) => {
    const {uiStore} = this.props;
    if (id === uiStore.openKeys) {
      uiStore.setOpenKeys('none');
    } else {
      uiStore.setOpenKeys(id);
    }
  };

  generateMenu = () => {
    const {uiStore, portalStore, appStore} = this.props;
    const menus = portalStore.currentAppMenus;
    const isNewNavigation = portalStore.isNewNavigation && appStore.appRunEnable;
    let defaultOpenKeys = '';
    const menuNodes = [];
    const sortedMenus = menus || [];
    const menuWidth = isNewNavigation ? '240px' : '200px';
    const style = portalStore.showMenu ? {display: 'block', width: menuWidth} : {display: 'none'};
    const currentSubMenu = (this.findMenuById(portalStore.workingMenu.id) || {}).parentId;

    if (sortedMenus.length > 0) {
      defaultOpenKeys = sortedMenus[0].id;
    }

    sortedMenus.forEach((item) => {
      if (item.children && item.children.length > 0 && (!isNewNavigation || (!item.additionType && isNewNavigation))) {
        menuNodes.push(
          <li {...{[['key'][0]]: item.id}} title={item.name} className={(uiStore.openKeys || defaultOpenKeys) === item.id ? 'sub-menu open' : 'sub-menu close'}>
            <div
              className={currentSubMenu && currentSubMenu === item.id ? 'sub-menu-title selected' : 'sub-menu-title'}
              onClick={() => this.toggleSubMenu(item.id)}
            >
              {
                isNewNavigation && <span className={item.icon && checkIconExist(item.icon) ? `${item.icon} parent-menu-icon` : 'icon_model parent-menu-icon'} />
              }
              <span className='title'>{item.name}</span>
              <i className={(uiStore.openKeys || defaultOpenKeys) === item.id ? 'dpl20_up_s' : 'dpl20_down_s'} />
            </div>
            <ul className='portal-sub-menu'>{(item.children || []).map(s => this.renderMenu(s))}</ul>
          </li>
        );
      } else {
        menuNodes.push(this.renderMenu(item));
      }
    });

    return (
      <ul className='app-menu' style={style}>{menuNodes}</ul>
    );
  };

  dfd = () => <span className='hint'>{localeText('PORTAL.BTN_CHANGE_APP')}</span>;

  renderSubMenus = menu => menu.map(item => (
    <Menu.Item {...{[['key'][0]]: item.id}} onClick={() => this.menuSelect(item)}>
      {item.icon && checkIconExist(item.icon) ? <i className={item.icon} /> : <i className='icon_model' />}
      <span>{item.name}</span>
    </Menu.Item>
  ))

  generateNewMenu = () => {
    const {portalStore} = this.props;
    const menus = portalStore.currentAppMenus;
    const selectedKeys = [portalStore.workingMenu.id, portalStore.workingMenu.parentId];

    const menuNodes = (menus || []).map(item => (item.children?.length && !item.additionType ? (
      <SubMenu {...{[['key'][0]]: item.id}} title={<div onClick={() => this.menuSelect(item)}>{item.icon && checkIconExist(item.icon) ? <i className={item.icon} /> : <i className='icon_model' />}</div>}>
        <Menu.ItemGroup title={item.name}>
          {item.additionType === 0 || item.additionType === null ? this.renderSubMenus(item.children) : null}
        </Menu.ItemGroup>
      </SubMenu>
    ) : (
      <Menu.Item {...{[['key'][0]]: item.id}} onClick={() => this.menuSelect(item)}>
        <Popover content={item.name} placement='right'>
          {item.icon && checkIconExist(item.icon) ? <i className={item.icon} /> : <i className='icon_model' />}
        </Popover>
      </Menu.Item>
    )));

    return (
      <Menu className='new-menu' theme='dark' selectedKeys={selectedKeys}>{menuNodes}</Menu>
    );
  };

  render() {
    const {sessionStore, prefixClass, newPrefixClass, uiStore, portalStore, organizationStore, appStore, onClose} = this.props;
    return (
      <>
        <div
          className={prefixClass}
          onClick={(e) => {
            if (!sessionStore.isMobile) {
              uiStore.toggleAppSwitcher(false);
            }
            e.stopPropagation();
          }}
        >
          {portalStore.workingApp && portalStore.workingApp.name && portalStore.showMenu ? (
            <div
              className={uiStore.showAppSwitcher ? 'app-name hover' : 'app-name'}
              onClick={(e) => {
                uiStore.toggleAppSwitcher();
                e.stopPropagation();
              }}
            >
              <span className='name' title={portalStore.workingApp.name}>
                {portalStore.workingApp.name}
              </span>
              <span className='change-app'>
                <Mobile>
                  <span className='hint'>{localeText('PORTAL.BTN_CHANGE_APP')}</span>
                </Mobile>
                <i className='dpl20_right' />
              </span>
              <AppSwitcher uiStore={uiStore} onClose={onClose} />
            </div>
          ) : (
            <Mobile>
              <div className='no-permission'>{localeText('COMMON.NOT_FOUND_MOBILE')}</div>
            </Mobile>
          )}
          {this.generateMenu()}
          {portalStore.showMenu && (
            <DesktopOrTablet>
              {sessionStore.showCopyright && (
                <div className='menu-copy-right'>
                  {organizationStore.editPersonality ? organizationStore.pageFooter[getLocale()] : (
                    <>
                      <span>&copy;</span>
                      {localeText('COMMON.TXT_COPY_RIGHT')}
                    </>
                  )}
                </div>
              )}
            </DesktopOrTablet>
          )}
        </div>
        {(!portalStore.showMenu || portalStore.viewMode === 1) && portalStore.isNewNavigation && appStore.appRunEnable && (
          <DesktopOrTablet>
            <div
              className={newPrefixClass}
              onClick={(e) => {
                if (!sessionStore.isMobile) {
                  uiStore.toggleAppSwitcher(false);
                }
                e.stopPropagation();
              }}
            >
              {portalStore.workingApp && portalStore.workingApp.name
              && (
                <div
                  className={uiStore.showAppSwitcher ? 'app hover' : 'app'}
                  onClick={(e) => {
                    uiStore.toggleAppSwitcher();
                    e.stopPropagation();
                  }}
                  onMouseEnter={() => this.props.uiStore.setIsHover(true)}
                  onMouseLeave={() => this.props.uiStore.setIsHover(false)}
                >
                  <Popover content={portalStore.workingApp.name} placement='right' visible={uiStore.isHover && !uiStore.showAppSwitcher} arrowPointAtCenter>
                    <span className='icon_product' />
                    <div className='app-bottom' />
                  </Popover>
                  <AppSwitcher uiStore={uiStore} onClose={onClose} />
                </div>
              )
              }
              {this.generateNewMenu()}
            </div>
          </DesktopOrTablet>
        )}
      </>
    );
  }
}

export default PortalMenu;
